const readQueue = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const writeQueue = (key, queue) => {
  try {
    localStorage.setItem(key, JSON.stringify(queue || []));
  } catch {}
};

export const OFFLINE_KEYS = {
  STOCK_IN: "inventory_stock_in_queue_v1",
  STOCK_OUT: "inventory_stock_out_queue_v1",
};

export const enqueueOffline = async (key, payload) => {
  const queue = readQueue(key);
  queue.push({
    payload,
    queued_at: Date.now(),
  });
  writeQueue(key, queue);
};

export const flushQueue = async (key, sender) => {
  const queue = readQueue(key);
  if (!queue.length) return 0;

  const remaining = [];
  let processed = 0;

  for (const entry of queue) {
    try {
      await sender(entry.payload);
      processed += 1;
    } catch {
      remaining.push(entry);
      break;
    }
  }

  if (processed === queue.length) {
    writeQueue(key, []);
  } else {
    writeQueue(key, remaining);
  }

  return processed;
};
